import React, { useEffect, useState, useRef } from "react";
// import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import Card from "@mui/material/Card";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { components } from "react-select";
import CreatableSelect from "react-select/creatable";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import cross from "../../assets/cross.svg";
import "./../../Bookclosure/Styles/Bookclosure.css";
import {
  removeAdjustmentFromTable,
  setAdjustments,
  setIsAddToTackModalOpen,
  setIsEditLedgerModal,
  setNewAdjustmentToTable,
  setOnchangeAdj,
  setTaskComments,
  addLedgerToAdjustment
} from "../../redux/actions/BookClosure/actionBookClosure";
import AddLedgerToTaskModal from "./AddLedgerToTaskModal";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import EditLedgerTaskModal from "./EditLedgerTaskModal";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  AddAdjustmentToTask, addCommentToTask, getOneTask, updateAdjustmentToTask, postReplyApiHandler, deleteCommentApiHandler,
  updateCommentApiHandler, updateConnectedTaskReviewApiHandler, reopenBookClosureTaskApiHandler, updateTaskAttachments, deleteTask
} from "../Services/ApiHandler";
import swal from "sweetalert";
import { toast } from "react-toastify";
import LoaderTwo from "../../Components/Common/Loader/LoaderTwo";


import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";
import bookclosuretaskscss from "../../myfin_v2/css/bookclosuretasks.module.css";
import commentscss from "../../myfin_v2/css/comments.module.css";
import modalcss from "../../myfin_v2/css/modal.module.css";
import Modal from "../../myfin_v2/elements/Modal";
import CustomDropdownIndicator from "../../myfin_v2/elements/CustomDropdownIndicator";
import ToggleButton from "../../myfin_v2/elements/ToggleButton";
import { Button, TableButton, IconButton } from "../../myfin_v2/elements/Button";
import Dropdown from "../../myfin_v2/elements/Dropdown";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import SearchableDropdown from "../../myfin_v2/elements/SearchableDropdown"
import SuccessModal from "../../myfin_v2/components/connections/SuccessModal";
import ErrorModal from "../../myfin_v2/components/connections/ErrorModal";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as LeftIcon } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as CalenderIcon } from "../../myfin_v2/assets/icons/calender.svg";
import { ReactComponent as RoundedCheckIcon } from "../../myfin_v2/assets/icons/rounded_check.svg";
import { ReactComponent as AttachmentIcon } from "../../myfin_v2/assets/icons/attachment.svg";
import { ReactComponent as PrimaryPlusIcon } from "../../myfin_v2/assets/icons/primary_plus.svg";
import { ReactComponent as DeleteRedIcon } from "../../myfin_v2/assets/icons/delete_red.svg";
import { ReactComponent as ReplyIcon } from "../../myfin_v2/assets/icons/reply.svg";
import { ReactComponent as MenuDotIcon } from "../../myfin_v2/assets/icons/menu_dot.svg";
import { ReactComponent as CloseGreyIcon } from "../../myfin_v2/assets/icons/close_grey.svg";
import { ReactComponent as EditIcon } from "../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as PdfIcon } from "../../myfin_v2/assets/icons/pdf.svg";
import { ReactComponent as ExcelIcon } from "../../myfin_v2/assets/icons/excel.svg";
import { ReactComponent as WordIcon } from "../../myfin_v2/assets/icons/word.svg";
import { ReactComponent as PptIcon } from "../../myfin_v2/assets/icons/ppt.svg";
import { ReactComponent as MailIcon } from "../../myfin_v2/assets/icons/mail.svg";
import { ReactComponent as DefaultFileIcon } from "../../myfin_v2/assets/icons/defaultFile.svg";
import { ReqFieldLabel } from "../../myfin_v2/components/mis";
import modules from "../../myfin_v2/data/modules.json"
import BookClosureModuleTasks from '../Components/BookClosureModuleTasks';
import BookClosureConnectedTasks from '../Components/BookClosureConnectedTasks';
import AddCommentModal from "../../myfin_v2/components/bookclosure/AddCommentModal";
import EditCommentModal from "../../myfin_v2/components/bookclosure/EditCommentModal";
import zIndex from "@mui/material/styles/zIndex";
import DefaultUserRound from "../../myfin_v2/assets/imgs/DefaultUserRound.png";


import { 
  isTaskNameDisabled,
  isTaskDescriptionDisabled,
  isModuleDisabled,
  isInputDisabled
} from "../../utils/taskAccess";



// export const customStyles = {
//   control: (provided, state) => ({
//     ...provided,
//     backgroundColor: '#f4faf5 !important',
//     borderColor: '#c2e6d1',
//     color: '#b3c0bd',
//     boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
//     borderWidth: '1px',
//     borderRadius: '6px',
//     '&:hover': {
//       borderColor: '#b3c0bd',
//     },
//     minHeight: '38px',
//     height: '38px',

//   }),
//   valueContainer: (provided) => ({
//     ...provided,
//     padding: '2px 8px',
//     paddingTop: '1px'
//   }),
//   input: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   placeholder: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     fontSize: "14px",
//     transform: 'translateY(-65%) !important'

//   }),
//   singleValue: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//     fontSize: "14px",
//     transform: 'translateY(-65%) !important'
//   }),
//   multiValue: (provided) => ({
//     ...provided,
//     backgroundColor: '#e0f5e9', // softer variant
//     borderRadius: '0.25rem',
//     border: '1px solid #c2e6d1',
//     width: 'fit-content'
//   }),
//   multiValueLabel: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//   }),
//   multiValueRemove: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       backgroundColor: '#c2e6d1',
//       color: '#4f665f',
//     },
//   }),
//   indicatorsContainer: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   dropdownIndicator: (provided, state) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   clearIndicator: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   menu: (provided) => ({
//     ...provided,
//     backgroundColor: '#f4faf5',
//     border: '1px solid #c2e6d1',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
//     borderRadius: '6px',
//     zIndex: 10,

//   }),
//   menuPortal: (provided) => ({
//     ...provided,
//     zIndex: 99999,
//   }),
//   menuList: (provided) => ({
//     ...provided,
//     padding: 0,

//   }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//         ? '#e9f7ef'
//         : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: "14px",

//   }),
//   noOptionsMessage: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     padding: '8px 12px',
//   }),
// };

export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
    borderWidth: '1px',
    borderRadius: '10px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '14px',
    marginTop: "-3px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#4d6d64',
    fontSize: '14px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9',
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#4d6d64',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#1A4338',
    marginTop: "-3px",
    fontWeight: 400,
    ':hover': {
      color: '#1A4338',
      fontWeight: 400,
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '6px',
    boxShadow: '0 0 0 1px #c2e6d1',
    marginTop: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '6px',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#c2e6d1'
      : state.isFocused
        ? '#f4faf5'
        : 'transparent',
    color: '#4f665f',
    padding: '10px 12px',
    cursor: 'pointer',
    fontSize: '14px',
    borderRadius: '8px',
    // margin: '4px 6px',
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};

export const customStylesWbg = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#ffffff',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
    borderWidth: '1px',
    borderRadius: '6px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#4d6d64',
    fontSize: '14px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9',
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#4d6d64',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#1A4338',
    ':hover': {
      color: '#1A4338',
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#1A4338',
    ':hover': {
      color: '#1A4338',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '6px',
    boxShadow: '0 0 0 1px #c2e6d1',
    marginTop: '6px',
    zIndex: 1000
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '6px',
    zIndex: 1000
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#c2e6d1'
      : state.isFocused
        ? '#f4faf5'
        : 'transparent',
    color: '#4f665f',
    padding: '10px 12px',
    cursor: 'pointer',
    fontSize: '14px',
    borderRadius: '8px',
    zIndex: 1000
    // margin: '4px 6px',
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999, // Make sure it's higher than modal
  }),
};



export const unresolvedCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#e5a503',
    // borderColor: '#c2e6d1',
    color: '#ffffff',
    boxShadow: 'none',
    borderWidth: '1px',
    borderRadius: '6px',
    '&:hover': {
      // borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px'
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px'
  }),
  input: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#ffffff',
    fontSize: "14px",
    transform: 'translateY(-65%) !important'

  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#ffffff',
    fontSize: "14px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "1px",
    transform: 'translateY(-65%) !important'
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9', // softer variant
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content'
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: '#ffffff',
    ':hover': {
      color: '#ffffff',
    },
    marginTop: "-6px"
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#ffffff',
    ':hover': {
      color: '#ffffff',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    border: '1px solid #ffffff',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
    borderRadius: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#c2e6d1'
      : state.isFocused
        ? '#e9f7ef'
        : 'transparent',
    color: '#4f665f',
    padding: '10px 12px',
    cursor: 'pointer',
    fontSize: "14px"
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};

export const resolvedCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#19a9e7',
    // borderColor: '#c2e6d1',
    color: '#ffffff',
    boxShadow: 'none',
    borderWidth: '1px',
    borderRadius: '6px',
    '&:hover': {
      // borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px'
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px'
  }),
  input: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#ffffff',
    fontSize: "14px",
    transform: 'translateY(-65%) !important'

  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#ffffff',
    fontSize: "14px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "1px",
    transform: 'translateY(-65%) !important'
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9', // softer variant
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content'
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: '#ffffff',
    ':hover': {
      color: '#ffffff',
    },
    marginTop: "-6px"
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#ffffff',
    ':hover': {
      color: '#ffffff',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    border: '1px solid #ffffff',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
    borderRadius: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#c2e6d1'
      : state.isFocused
        ? '#e9f7ef'
        : 'transparent',
    color: '#4f665f',
    padding: '10px 12px',
    cursor: 'pointer',
    fontSize: "14px"
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};


export const closedCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#349f6f',
    // borderColor: '#c2e6d1',
    color: '#ffffff',
    boxShadow: 'none',
    borderWidth: '1px',
    borderRadius: '6px',
    '&:hover': {
      // borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px'
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px'
  }),
  input: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#ffffff',
    fontSize: "14px",
    transform: 'translateY(-65%) !important'

  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#ffffff',
    fontSize: "14px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "1px",
    transform: 'translateY(-65%) !important'
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9', // softer variant
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content'
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: '#ffffff',
    ':hover': {
      color: '#ffffff',
    },
    marginTop: "-6px"
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#ffffff',
    ':hover': {
      color: '#ffffff',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    border: '1px solid #ffffff',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
    borderRadius: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#c2e6d1'
      : state.isFocused
        ? '#e9f7ef'
        : 'transparent',
    color: '#4f665f',
    padding: '10px 12px',
    cursor: 'pointer',
    fontSize: "14px"
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};

export const overdueCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f00808',
    // borderColor: '#c2e6d1',
    color: '#ffffff',
    boxShadow: 'none',
    borderWidth: '1px',
    borderRadius: '6px',
    '&:hover': {
      // borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px'
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px'
  }),
  input: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#ffffff',
    fontSize: "14px",
    transform: 'translateY(-65%) !important'

  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#ffffff',
    fontSize: "14px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "1px",
    transform: 'translateY(-65%) !important'
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9', // softer variant
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content'
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: '#ffffff',
    ':hover': {
      color: '#ffffff',
    },
    marginTop: "-6px"
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#ffffff',
    ':hover': {
      color: '#ffffff',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    border: '1px solid #ffffff',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
    borderRadius: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#c2e6d1'
      : state.isFocused
        ? '#e9f7ef'
        : 'transparent',
    color: '#4f665f',
    padding: '10px 12px',
    cursor: 'pointer',
    fontSize: "14px"
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};

const AddTaskModal = ({
  isAddTaskModal,
  setAddTaskForm,
  addTaskForm,
  AddTask,
  handleTaskModalClose,
  ReturnTask,
  isTaskAction,
  userData,
  AddLedgerToTask,
  UpdateLedgerInTask,
  tagLedgers,
  connectedTasks,
  ViewTaskMore,
  addedColumns,
  taskDetails,
  checkReviewed,
  prevTaskId,
  moduleNamesList,
  taskAttachmentsForm,
  setTaskAttachmentsForm,
  existingFiles,
  setExistingFiles,
  DeleteTask,
  usersData,
  bookclosureTags,
  SubmitTask,
  ApproveTask
}) => {

  // console.log("AddTask",AddTask);
  console.log("isTaskAction",isTaskAction);
  
  const animatedComponents = makeAnimated();
  const dispatch = useDispatch();
  const { assignOptions, approveOptions, comments, adjustments, ledgers, bookClosureTasks } = useSelector(
    (state) => state.BookClosureReducer
  );
  const commentStatuses = [{ "label": "Unresolved", "value": "unresolved" }, { "label": "Resolved", "value": "resolved" },
  { "label": "Closed", "value": "closed" }, { "label": "OverDue", "value": "overdue" }]
  const [ledgerDetails, setLedgerDetails] = useState({
    remark: "",
    amount: "",
    ledgerId: "",
  });
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [taskColumnList, setTaskColumnList] = useState([])
  const [addCommentModal, setAddCommentModal] = useState(false);
  const [editCommentModal, setEditCommentModal] = useState(false);
  const [editComment, setEditComment] = useState({});
  const [commentsList, setCommentsList] = useState([]);
  const [showCommentThread, setShowCommentThread] = useState(false);
  const [selComment, setCommentText] = useState([]);
  const [commentReply, setCommentReply] = useState("");
  const [disableActions, setDisableAction] = useState(false);
  const [reOpenTask, setReOpenTask] = useState(false);
  const [taskComment, setTaskComment] = useState("");
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [ isAdminUser, setIsAdminUser ] = useState(userData?.isAdmin === "Yes" ? true : false)
  
  const [displayModal, setDisplayModal] = useState(false);
  const [deleteTaskModal, setDeleteTaskModal] = useState(false);
  const [showSuccessToaster, setShowSuccessToaster] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showErrorToaster, setShowErrorToaster] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loggedUser, setloggedUser] = useState(null);

  // const ledgerOptions = ledgers.map((ledger) => ({
  //   value: ledger.ledgerCode,
  //   label: ledger.ledgerCode,
  // }));
  useEffect(() => {
    setCommentsList(comments.reverse());

  }, [comments])
  const handleSelectChange = (selectedOptions, { name }) => {
    if (name === "linkedLedgers") {

      setAddTaskForm((prev) => ({
        ...prev,
        linkedLedgers: selectedOptions,
      }));
      // setAddTaskForm((prev) => ({
      //   ...prev,
      //   [name]: selectedOptions.map((option) => option.ledgerCode),
      // }));
    }
    if (name === "assigneeID") {
      setAddTaskForm((prev) => ({
        ...prev,
        selectedAssignId: selectedOptions,
      }));
      setAddTaskForm((prev) => ({
        ...prev,
        [name]: selectedOptions.map((option) => option.value),
      }));
    } if (name === "approverID") {

      setAddTaskForm((prev) => ({
        ...prev,
        selectedApproverId: selectedOptions,
      }));
      setAddTaskForm((prev) => ({ ...prev, [name]: selectedOptions.value }));
    }
  };

  const AddComment = () => {
    if (!addTaskForm.taskId) {
      // toast.warning("Please Save The Task.");
      swal("Please Save The Task.",'warning');
      return;
    }
    setLoading(true);
    addCommentToTask(addTaskForm.taskId, {
      text
    }).then(res => {
      // toast.success("Comment added successfully.");
      getOneTask(addTaskForm.taskId).then(response => {
        const taskData = response.data.bookClosureTask;


        dispatch(setTaskComments(taskData.comments));
        setText("");
      }).catch(error => {
        swal("Error", `Error: ${error.response?.data?.error}` || "Task not found!", 'error');
      })
    }).catch(error => {
      swal("Error", `Error: ${error.response?.data?.error}` || "Comment Send Failed!", 'error');
    }).finally(() => setLoading(false))
  }

  const SaveSingleAdj = (adjData) => {
    if (adjData?._id) {
      updateAdjustmentToTask(addTaskForm.taskId, adjData?._id, {
        date: dayjs(adjData.date).format("DD-MM-YYYY"),
        addedLedgers: adjData.addedLedgers.map(({ _id, ...rest }) => rest),
        remarks: adjData.remarks
      }).then(res => {
        // toast.success("Adjustment updated successfully.");
        swal("Success", "Adjustment updated successfully.", 'success')

        getOneTask(addTaskForm.taskId).then(response => {
          const taskData = response.data.bookClosureTask;
          dispatch(setAdjustments(taskData.adjustments));
        }).catch(error => {
          swal("Error", `Error: ${error.response?.data?.error}` || "Task not found!", 'error');
        });

      }).catch(error => {
        swal("Error", `Error: ${error.response?.data?.error}` || "Adjustment Update Failed!", 'error');
      })
    } else {
      AddAdjustmentToTask(addTaskForm.taskId, {
        date: dayjs(adjData.date).format("DD-MM-YYYY"),
        addedLedgers: adjData.addedLedgers,
        remarks: adjData.remarks
      }).then(res => {
        // toast.success("Adjustment added successfully.");
        swal("Success", "Adjustment added successfully.", 'success')

        getOneTask(addTaskForm.taskId).then(response => {
          const taskData = response.data.bookClosureTask;

          dispatch(setAdjustments(taskData.adjustments));

        }).catch(error => {
          swal("Error", `Error: ${error.response?.data?.error}` || "Task not found!", 'error');
        });

      }).catch(error => {
        swal("Error", `Error: ${error.response?.data?.error}` || "Adjustment Save Failed!", 'error');
      })
    }
  }

  const columnsData = () => {


    if (addedColumns && addedColumns.length > 0) {
      addedColumns.map((addedColumn, index) => {
        let columnObj = {
          taskID: addTaskForm.taskId,
          columnId: addedColumn.columnID,
          columnTitle: addedColumn.columnTitle,
          columnType: addedColumn.columnType,
          columnValue: ""
        }
        if (taskDetails) {
          const taskColumn = taskDetails?.columns.find(item => item.columnId === addedColumn.columnID)
          if (taskColumn) {
            columnObj["columnValue"] = taskColumn.columnValue
          }
        }
        setTaskColumnList((prev) => [...prev, columnObj]);
      })
    }
  }


  useEffect(() => {
    setTaskColumnList([])
    columnsData();
    if (taskDetails) {
      if (((userData?.isAdmin === "Yes") || taskDetails.assigneeIDs.includes(userData?._id)  || taskDetails?.approverID === userData?._id )&& taskDetails.status === "approved") {
        setReOpenTask(true);
      } else {
        setReOpenTask(false);
      }
    }

  }, [taskDetails])



  useEffect(() => {
    if ((userData?.responsibilities === "approver") || (checkReviewed !== "N")) {
      setDisableAction(true);
    } else {
      setDisableAction(false);
    }
  }, [userData, checkReviewed])

  useEffect(() => {
    addTaskForm.columns = taskColumnList
      .filter(item => item.columnValue?.toString().trim() !== "")
      .map(item => ({
        columnId: item.columnId,
        columnValue: item.columnValue,
        columnType: item.columnType
      }));

  }, [taskColumnList])

  const commentThreadHandler = (commentId) => {
    const selComment = commentsList.filter(comment => comment._id === commentId);
    setCommentText(selComment);
    setShowCommentThread(true);
  }

  const postCommentReply = (commentId, taskId) => {
    if (!taskId) {
      // toast.warning("Please Save The Task.");
      swal("Please Save The Task.",'warning');
      return;
    }
    const payload = {
      taskID: taskId,
      commentID: commentId,
      replyText: commentReply,
    };
    postReplyApiHandler(payload)
      .then((response) => {
        ViewTaskMore(addTaskForm.taskId);
        // setCommentsList((response.data.comments).reverse());
        // toast.success("Reply posted successfully.");
        swal("Success", "Reply posted successfully.", 'success')
        setShowCommentThread(false);
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable post reply",
          "error"
        );
      });
  }

  const [selectComment, setSelectComment] = useState(null); // ID of clicked column
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const thRefs = useRef({}); // refs for each <th>
  const hoverTimeout = useRef(null);


  const handleClick = (columnId, comment) => {
    const rect = thRefs.current[columnId].getBoundingClientRect();
    setPopupPosition({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
    });
    setSelectComment(columnId);
    setEditComment(comment);
  };

  const handleMouseLeave = () => {
    hoverTimeout.current = setTimeout(() => {
      setSelectComment(null);
    }, 200);
  };

  const handlePopupEnter = () => {
    clearTimeout(hoverTimeout.current);
  };

  const deleteComment = (commentId) => {

    const payload = {
      taskID: addTaskForm.taskId,
      commentID: commentId,
    };
    deleteCommentApiHandler(payload)
      .then((response) => {
        ViewTaskMore(addTaskForm.taskId)
        // setCommentsList((response.data.comments).reverse());
        // toast.success("Comment deleted successfully.");
        swal("Success", "Comment deleted successfully.", 'success')
        setShowCommentThread(false);
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable post reply",
          "error"
        );
      });
  }

  const updateCommentStatus = (commentId, assignee, status) => {
    const payload = {
      taskID: addTaskForm.taskId,
      commentID: commentId,
      assignee: assignee,
      status: status
    };

    updateCommentApiHandler(payload)
      .then((response) => {
        // setCommentsList((response.data.comments).reverse());
        ViewTaskMore(addTaskForm.taskId)
        setShowCommentThread(false);
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to update status",
          "error"
        );
      });
  }

  const updateConnectedTaskReview = (isReviewed) => {
    const payload = {
      taskID: prevTaskId,
      reviewedTasks: [
        {
          taskID: addTaskForm.taskId,
          reviewed: isReviewed
        }
      ]
    };

    updateConnectedTaskReviewApiHandler(payload)
      .then((response) => {
        // toast.success("Task marked as Reviewed");
        swal("Success", "Task marked as Reviewed", 'success')
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to update status",
          "error"
        );
      });
  }
  
  console.log("======",isInputDisabled({ taskDetails, userData, roles: ["Admin", "task-approver"] }))

  const reopenTaskHandler = () => {

    const params = { id: addTaskForm.taskId }

    reopenBookClosureTaskApiHandler(params)
      .then((response) => {
        if (response.data.success) {
          // toast.success("Task reopened successfully");
          swal("Success", "Task reopened successfully", 'success')
          setReOpenTask(false);
        } else {
          swal(
            "Error",
            "Unable to reopen task",
            "error"
          );
        }

      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to reopen task",
          "error"
        );
      });
  }


  const reviewAllTasks = () => {
    console.log("connectedTasks", connectedTasks)
    const reviewedTaskObjects = connectedTasks.map(task => ({
      taskID: task._id,
      reviewed: true
    }));
    console.log("reviewedTaskObjects", reviewedTaskObjects)

    const payload = {
      taskID: addTaskForm.taskId,
      reviewedTasks: reviewedTaskObjects
    }

    updateConnectedTaskReviewApiHandler(payload)
      .then((response) => {
        if (response.data.success) {
          // toast.success("Tasks marked as Reviewed");
          swal("Success", "Tasks marked as Reviewed", 'success')
        } else {
          swal(
            "Error",
            "Unable to update status",
            "error"
          );

        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to update status",
          "error"
        );
      });

  }


  const handleRemoveExisting = (fileId) => {
    setExistingFiles((prev) => {
      const updatedExistingFiles = prev.filter((f) => f._id !== fileId);

      // Update FormData
      setTaskAttachmentsForm((prevFormData) => {
        const formData = prevFormData || new FormData();
        const newFormData = new FormData();

        // Keep everything except old existingFiles entries
        formData.forEach((value, key) => {
          if (key !== "existingFiles[]") {
            newFormData.append(key, value);
          }
        });

        // Append **remaining** existing file IDs
        updatedExistingFiles.forEach((f) => {
          newFormData.append("existingFiles[]", f._id);
        });

        // Keep new attachments
        attachedFiles.forEach((f) => {
          newFormData.append("attachments", f);
        });

        // Include task IDs
        newFormData.set("taskID", addTaskForm.taskId);
        newFormData.set("bookclosureID", addTaskForm.bookClosureID);

        return newFormData;
      });

      return updatedExistingFiles;
    });
  };

  const handleRemoveNew = (index) => {
    setAttachedFiles((prev) => {
      const updatedNewFiles = prev.filter((_, i) => i !== index);

      // Update FormData
      setTaskAttachmentsForm((prevFormData) => {
        const formData = new FormData();

        // Add remaining new files
        updatedNewFiles.forEach((file) => formData.append("attachments", file));

        // Add existing file IDs
        existingFiles.forEach((file) => {
          if (file._id) formData.append("existingFiles[]", file._id);
        });

        formData.set("taskID", addTaskForm.taskId);
        formData.set("bookclosureID", addTaskForm.bookClosureID);

        return formData;
      });

      return updatedNewFiles;
    });
  };

  const handleFilesChange = (e) => {
    
    const selectedFiles = Array.from(e.target.files);
    setAttachedFiles((prev) => {
      const updatedNewFiles = [...prev, ...selectedFiles];

      setTaskAttachmentsForm(() => {
        const formData = new FormData();

        // Existing file IDs
        existingFiles.forEach((file) => {
          if (file._id) formData.append("existingFiles[]", file._id);
        });

        // New files
        updatedNewFiles.forEach((file) => formData.append("attachments", file));

        formData.set("taskID", addTaskForm.taskId);
        formData.set("bookclosureID", addTaskForm.bookClosureID);

        return formData;
      });

      return updatedNewFiles;
    });
  };




  const getFileIcon = (fileName) => {
    const ext = fileName.split(".").pop().toLowerCase();

    switch (ext) {
      case "pdf":
        return <PdfIcon />;
      case "doc":
      case "docx":
        return <WordIcon />;
      case "xls":
      case "xlsx":
        return <ExcelIcon />;
      case "ppt":
      case "pptx":
        return <PptIcon />;
      case "eml":
      case "msg":
        return <MailIcon />;
      default:
        return <DefaultFileIcon />;
    }
  };

  const filteredAssignOptions = assignOptions.filter(
    (option) => option.value !== addTaskForm.selectedApproverId?.value
  );

  const filteredApproveOptions = approveOptions.filter(
    (option) => !addTaskForm.selectedAssignId.some(assign => assign.value === option.value)
  );


  // Task inputs check role wise(IAM)
  const [taskNameDisabled, setTaskNameDisabled] = useState(false)
  const [taskDescriptionDisabled, setTaskDescriptionDisabled] = useState(false);
  const [moduleDisabled, setModuleDisabled] = useState(false);
  
  useEffect(() => {
    setTaskNameDisabled(isTaskNameDisabled({ taskDetails, userData }));
    setTaskDescriptionDisabled(isTaskDescriptionDisabled({ taskDetails, userData }));
    setModuleDisabled(isModuleDisabled({ taskDetails, userData }));
  }, [taskDetails, userData]);
  

  useEffect(() => {
    if (usersData && usersData.length > 0) {
      const logged = usersData.find(u => u.isLoggedUser === true) || null;
      setloggedUser(logged);
    }
  }, [usersData]);

  console.log("taskDetails",taskDetails);
  console.log("userData",userData);
  

  return (
    <>
      {isAddTaskModal && (
        <Modal
          title="Tasks"
          width="90%"
          bodycss={commoncss.unsetPadding}
          bodyStyle={{ "overflow": "hidden" }}
          navigateBack=
          {checkReviewed !== "N" ? (<LeftIcon className={`${commoncss.clickable} mr-2`} style={{ "vertical-align": "baseline" }} onClick={() => { ViewTaskMore(prevTaskId) }} />) : ""}

          headerActions={
            <>
              <div className={`${commoncss.dFlex}`}>

                {isAdminUser && isTaskAction &&(
                  <>
                    <button
                      className={`${buttoncss.custom_btn} ${buttoncss.secondary}`}
                      style={{ border: "none", color:"#E30000", fontSize:"15px" }}
                      onClick={() => {
                        setDisplayModal(true);
                        setDeleteTaskModal(true);
                      }}
                    >
                      <DeleteRedIcon style={{ height:"16px" }} />
                      Delete
                    </button>&ensp;
                  </>
                )}

                {checkReviewed === "N" && (<ToggleButton
                  label={"Confidential"}
                  value={addTaskForm.isConfidential}
                  onToggle={(e) => {
                    const canToggle = !isInputDisabled({
                      taskDetails,
                      userData,
                      roles: ["Admin", "approver", "task-approver", "task-preparer"]
                    });

                    const canRemove = !isInputDisabled({
                      taskDetails,
                      userData,
                      roles: ["Admin", "approver", "task-approver"]
                    });

                    if ((addTaskForm.isConfidential && canRemove) || (!addTaskForm.isConfidential && canToggle)) {
                      setAddTaskForm((prev) => ({ ...prev, isConfidential: e }));
                    }

                    // setAddTaskForm((prev) => ({
                    //   ...prev,
                    //   isConfidential: e,
                    // }));
                  }}
                  disabled={isInputDisabled({ taskDetails, userData, roles: ["Admin", "approver", "task-approver"] })}
                />)}&ensp;

                {checkReviewed !== "N" && (
                  <>
                    <button
                      className={`${buttoncss.custom_btn} ${buttoncss.secondary}`}
                      onClick={() => { updateConnectedTaskReview(true) }}
                    >
                      Reviewed
                    </button>&ensp;
                  </>
                )}

                {checkReviewed === "N" && reOpenTask && (
                  <>
                    <button
                      className={`${buttoncss.custom_btn} ${buttoncss.secondary}`}
                      onClick={() => { reopenTaskHandler() }}
                    >
                      Re-open Task
                    </button>&ensp;
                  </>
                )}

                <CloseIcon
                  onClick={() => { handleTaskModalClose(); }}
                  className="clickable"
                />
              </div>
            </>
          }
          footerActions={
            <>
              <span></span>
              {addTaskForm.status !== "approved" && (
                <>
                  {addTaskForm.status === "open" && taskDetails?.assigneeIDs?.includes(userData?._id) && (
                    <button
                      className={`${buttoncss.custom_btn} ${buttoncss.primary}`}
                      onClick={SubmitTask}
                    >
                      Submit
                    </button>
                  )}

                  {addTaskForm.status === "submitted" && taskDetails?.approverID === userData?._id && (
                    <span>
                      <button
                        className={`${buttoncss.custom_btn} ${buttoncss.primary}`}
                        onClick={ApproveTask}
                      >
                        Approve
                      </button>&ensp;&ensp;
                      <button
                        className={`${buttoncss.custom_btn} ${buttoncss.primary}`}
                        onClick={ReturnTask}
                      >
                        Return
                      </button>
                    </span>
                  )}

                  {!(
                    (addTaskForm.status === "open" && taskDetails?.assigneeIDs?.includes(userData?._id)) ||
                    (addTaskForm.status === "submitted" && taskDetails?.approverID === userData?._id)
                  ) && (
                    <button
                      className={`${buttoncss.custom_btn} ${buttoncss.primary}`}
                      onClick={AddTask}
                    >
                      {isTaskAction ? "Update" : "Save"}
                    </button>
                  )}
                </>
              )}
              {/* <span>
                <button
                  className={`${buttoncss.custom_btn} ${buttoncss.primary}`}
                  onClick={AddTask}
                >
                  {userData?.responsibilities === "approver"
                    ? "Approve"
                    : userData?.responsibilities === "preparer"
                      ? "Submit"
                      : isTaskAction
                        ? "Update"
                        : "Save"}
                </button>&ensp;&ensp;
                {userData?.responsibilities === "approver" && (
                  <button
                    className={`${buttoncss.custom_btn} ${buttoncss.primary}`}
                    onClick={ReturnTask}
                  >
                    Return
                  </button>
                )}
              </span> */}
            </>
          }
          onClose={() => console.log("Modal Closed")}
        >
          <div class={`${commoncss.pdlr15} ${bookclosuretaskscss.taskContainer}`} style={{ "overflow": "hidden" }}>
            <div
              class={`${commoncss.pdlr15}  ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerLeft}`}
              style={{ "overflow": "auto", "height": "65vh" }}
            >
              <InputGroup

                label="Task Name"
                req={true}
                inputs={[
                  <>
                    <input
                      name="name"
                      value={addTaskForm.name}
                      placeholder="Enter task name"
                      // className={`${disableActions ? commoncss.noActions : ''}`}
                      onChange={(e) =>
                        setAddTaskForm((prev) => ({
                          ...prev,
                          name: e.target.value,
                        }))
                      }
                      disabled={isInputDisabled({ taskDetails, userData, roles: ["Admin", "approver"] })}
                    />
                  </>,
                ]}
              />

              <InputGroup

                label="Module Name"
                req={true}
                inputs={[
                  <>
                    {/* <input
                      name="module"
                      placeholder="Enter module name"
                      value={addTaskForm.module}
                      className={`${disableActions ? commoncss.noActions : ''}`}
                      onChange={(e) =>
                        setAddTaskForm((prev) => ({
                          ...prev,
                          module: e.target.value,
                        }))
                      }
                    /> */}
                    {/* <SearchableDropdown options = {['Apple', 'Banana', 'Mango', 'Orange', 'Grapes']}/> */}
                    <SearchableDropdown
                      name="module"
                      // className={`${disableActions ? commoncss.noActions : ''}`}
                      options={moduleNamesList}
                      onSelect={(val) => {
                        console.log("module name val", val);
                        setAddTaskForm((prev) => ({
                          ...prev,
                          module: val,
                        }));
                      }}
                      defaultValue={addTaskForm.module}
                      disabled={isInputDisabled({
                        taskDetails,
                        userData,
                        roles: ["Admin", "approver","task-approver","task-preparer"],
                        lockOnLibraryTask: true
                      })}
                    />
                  </>,
                ]}
              />

              {/* <Dropdown
                label="Module Name"
                req={true}
                options={modules}
                name="module"
                onSelect={(value) => {
                  setAddTaskForm((prev) => ({
                    ...prev,
                    module: value.value,
                  }))
                }}
                placeHolder={"Select Module"}
                selValue={addTaskForm.module}
              /> */}
              <InputGroup
                label="Task Description"
                req={true}
                inputs={[
                  <>
                    <textarea
                      // className={`${disableActions ? commoncss.noActions : ''}`}
                      rows={4}
                      placeholder="Enter task description"
                      name="description"
                      value={addTaskForm.description}
                      onChange={(e) =>
                        setAddTaskForm((prev) => ({
                          ...prev,
                          description: e.target.value,
                        }))
                      }
                      disabled={isInputDisabled({ taskDetails, userData, roles: ["Admin", "approver","task-approver","task-preparer"] })}
                    />
                  </>,
                ]}
              />
              <span className="input-label"><ReqFieldLabel />&nbsp;Assignee</span>
              <Select
                isMulti
                placeholder="Select assignee"
                name="assigneeID"
                value={addTaskForm.selectedAssignId}
                onChange={handleSelectChange}
                options={filteredAssignOptions}
                className={`basic-multi-select w-100 mt-1 mb-2`}
                classNamePrefix="select"
                components={{
                  ...animatedComponents,
                  IndicatorSeparator: () => null,
                  DropdownIndicator: CustomDropdownIndicator,
                }}
                closeMenuOnSelect={false}
                styles={customStyles}
                
                isDisabled={isInputDisabled({ taskDetails, userData, roles: ["Admin", "task-approver"]})}
              />
              <InputGroup
                inputs={[
                  <>
                    {/* <Dropdown
                      label="Approver"
                      req={true}
                      options={approveOptions}
                      onSelect={(value) => { }}

                      placeHolder={"Select Approver"}
                    /> */}
                    <span className="input-label"><ReqFieldLabel />&nbsp;Approver</span>
                    <Select
                      placeholder="Select approver"
                      name="approverID"
                      value={Object.keys(addTaskForm.selectedApproverId).length === 0 ? null : addTaskForm.selectedApproverId}
                      onChange={handleSelectChange}
                      options={filteredApproveOptions}
                      className={`w-100 mt-0`}
                      classNamePrefix="select"
                      components={{
                        ...animatedComponents,
                        IndicatorSeparator: () => null,
                        DropdownIndicator: CustomDropdownIndicator,
                      }}
                      styles={customStyles}
                      isDisabled={isInputDisabled({ taskDetails, userData, roles: ["Admin", "task-approver"]})}
                    />

                  </>,
                  <>
                    <InputGroup
                      label="Due Date"
                      req={true}
                      inputs={[
                        <>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                              <MobileDatePicker
                                disabled={isInputDisabled({ taskDetails, userData, roles: ["Admin", "task-approver"]})}
                                className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                value={addTaskForm.dueDate ? dayjs(addTaskForm.dueDate) : null}
                                onChange={(value) => {
                                  setAddTaskForm((prev) => ({
                                    ...prev,
                                    dueDate: value,
                                  }));
                                }}
                                format="DD-MMM-YYYY"
                                slotProps={{
                                  textField: {
                                    InputProps: {
                                      disableUnderline: true,
                                    },
                                    inputProps: {
                                      placeholder: "DD-MM-YYYY",
                                    },
                                    sx: {
                                      '& fieldset': {
                                        border: 'none',
                                      },
                                    },
                                  },
                                }}
                              />

                            </DemoContainer>
                          </LocalizationProvider>
                          <span className="icon">
                            <CalenderIcon
                              className="vaMiddle"
                              width={20}
                              height={20}
                            />
                          </span>
                        </>,
                      ]}
                    />
                  </>,
                ]}
              />
              {taskColumnList && taskColumnList.length > 0 && (
                <InputGroup
                  inputs={taskColumnList.map((addedColumn, index) => (
                    <InputGroup
                      key={addedColumn.columnId}
                      label={addedColumn.columnTitle}
                      inputs={[
                        addedColumn.columnType === "longText" ? (
                          <textarea
                            placeholder={`${addedColumn.columnTitle}`}
                            // className={`${disableActions ? commoncss.noActions : ''}`}
                            key={addedColumn.columnId}
                            value={addedColumn?.columnValue || ""}
                            onChange={(e) => {
                              const updatedValue = e.target.value;
                              setTaskColumnList((prevList) =>
                                prevList.map((item, i) =>
                                  i === index ? { ...item, columnValue: updatedValue } : item
                                )
                              );
                            }}
                          />
                        ) : 
                        addedColumn.columnType === "date" ? (
                          <>
                            <LocalizationProvider dateAdapter={AdapterDayjs} key={addedColumn.columnId}>
                              <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                                <MobileDatePicker
                                  className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                  value={addedColumn.columnValue ? dayjs(addedColumn.columnValue, "DD-MM-YYYY") : null}
                                  onChange={(newValue) => {
                                    const formattedValue = newValue ? dayjs(newValue).format("DD-MM-YYYY") : "";
                                    setTaskColumnList((prevList) =>
                                      prevList.map((item, i) =>
                                        i === index ? { ...item, columnValue: formattedValue } : item
                                      )
                                    );
                                  }}
                                  format="DD-MMM-YYYY"
                                  slotProps={{
                                    textField: {
                                      InputProps: { disableUnderline: true },
                                      inputProps: { placeholder: "DD-MM-YYYY" },
                                      sx: { '& fieldset': { border: 'none' } },
                                    },
                                  }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                            <span className="icon">
                              <CalenderIcon
                                className="vaMiddle"
                                width={20}
                                height={20}
                              />
                            </span>
                          </>
                        ):
                        addedColumn.columnType === "people" ? (
                          <Select
                            isMulti
                            placeholder="Select User"
                            value={assignOptions.filter(opt => 
                              Array.isArray(addedColumn.columnValue) && addedColumn.columnValue.includes(opt.value)
                            )}
                            onChange={(selectedOptions) => {
                              setTaskColumnList((prevList) =>
                                prevList.map((item, i) =>
                                  i === index ? { ...item, columnValue: selectedOptions.map(opt => opt.value) } : item
                                )
                              );
                            }}
                            options={assignOptions}
                            className={`basic-multi-select w-100 mt-1 mb-2}`}
                            classNamePrefix="select"
                            components={{
                              ...animatedComponents,
                              IndicatorSeparator: () => null,
                              DropdownIndicator: CustomDropdownIndicator,
                            }}
                            closeMenuOnSelect={false}
                            styles={{
                              ...customStyles,
                              control: (provided, state) => ({
                                ...(customStyles.control ? customStyles.control(provided, state) : provided),
                                minHeight: "auto",
                                height: "auto",
                              }),
                            }}
                          />
                        ) :

                        addedColumn.columnType === "tag" ? (
                          <CreatableSelect
                            isMulti
                            value={Array.isArray(addedColumn.columnValue)
                              ? addedColumn.columnValue.map((val) => ({ value: val, label: val }))
                              : []}
                            onChange={(selectedOptions) => {
                              // Restrict to max 5 tags
                              if (selectedOptions.length <= 5) {
                                setTaskColumnList((prevList) =>
                                  prevList.map((item, i) =>
                                    i === index
                                      ? { ...item, columnValue: selectedOptions.map((opt) => opt.value) }
                                      : item
                                  )
                                );
                              }
                            }}
                            options={bookclosureTags.map((tag) => ({ value: tag, label: tag }))}
                            onCreateOption={(inputValue) => {
                              const newOption = { value: inputValue, label: inputValue };
                              setTaskColumnList((prevList) =>
                                prevList.map((item, i) =>
                                  i === index
                                    ? {
                                        ...item,
                                        columnValue: item.columnValue
                                          ? [...item.columnValue, newOption.value].slice(0, 5)
                                          : [newOption.value],
                                      }
                                    : item
                                )
                              );
                            }}
                            placeholder="Select or create tags..."
                            closeMenuOnSelect={false}
                            isClearable
                            styles={{
                              ...customStyles,
                              control: (provided, state) => ({
                                ...(customStyles.control ? customStyles.control(provided, state) : provided),
                                minHeight: "auto",
                                height: "auto",
                              }),
                            }}
                            isDisabled={isInputDisabled({ taskDetails, userData, roles: ["Admin","task-approver","task-preparer"] })}
                          />
                        ):
                        (
                          <input
                            key={addedColumn.columnId}
                            // type={addedColumn.columnType === "date" ? "date" : "text"}
                            type="text"
                            // className={`${disableActions ? commoncss.noActions : ''}`}
                            placeholder={`${addedColumn.columnTitle}`}
                            value={addedColumn?.columnValue || ""}
                            onChange={(e) => {
                              const updatedValue = e.target.value;
                              setTaskColumnList((prevList) =>
                                prevList.map((item, i) =>
                                  i === index ? { ...item, columnValue: updatedValue } : item
                                )
                              );
                            }}
                          />
                        ),
                      ]}
                    />
                  ))}
                />
              )}

              <span className="input-label">Tag Linked Ledgers</span>
              <Select
                isMulti
                placeholder="Select Ledgers"
                name="linkedLedgers"
                value={addTaskForm.linkedLedgers}
                onChange={handleSelectChange}
                options={tagLedgers}
                getOptionLabel={(e) => e.ledgerName}
                getOptionValue={(e) => e.ledgerCode}
                className={`basic-multi-select w-100 mt-1 mb-2`}
                classNamePrefix="select"
                components={{
                  ...animatedComponents,
                  IndicatorSeparator: () => null,
                  DropdownIndicator: CustomDropdownIndicator,
                }}
                closeMenuOnSelect={false}
                styles={customStyles}
                isDisabled={isInputDisabled({ taskDetails, userData, roles: ["Admin", "task-approver","task-preparer"]})}
              />
              <InputGroup
                label="Comments"
                inputs={[
                  <>
                    <span className={commoncss.imgIconInput}>
                      <img className="vaMiddle" style={{ "borderRadius": "50%" }} width={32} height={32} src={loggedUser?.profile_image || DefaultUserRound} alt="user_image" />
                      <input 
                        type="text"
                        value={taskComment} 
                        placeholder="Add Comment" 
                        onChange={(e) => { setTaskComment(e.target.value) }} 
                        disabled={isInputDisabled({ taskDetails, userData, roles: ["Admin","approver","task-approver","task-preparer"] })}
                      />
                      <span 
                        className="icon" 
                        style={{ cursor: "pointer", pointerEvents: "auto" }} 
                        // onClick={setAddCommentModal}
                        onClick={
                          !isInputDisabled({ taskDetails, userData, roles: ["Admin","approver","task-approver","task-preparer"] })
                            ? setAddCommentModal
                            : undefined
                        }
                      >
                        <RoundedCheckIcon
                          className="vaMiddle"
                          width={20}
                          height={20}
                        />
                      </span>
                    </span>
                  </>,
                ]}
              />

              {commentsList && !showCommentThread && commentsList.length > 0 && (
                commentsList.map((comment, index) => {

                  const createdByUser = usersData.find(u => u._id === comment.createdBy) || null;

                  const assigneeUser = usersData.find(u => u._id === comment.assignee) || null;

                  return(
                    <>
                      <div className={`mt-1 mb-2 ${commentscss.commentsCard}`} key={index}>
                        <div className={commoncss.flexCenter} style={{ "justify-content": "space-between" }}>
                          <div>
                            <img className="vaMiddle" style={{ "borderRadius": "50%" }} width={30} height={30} src={createdByUser?.profile_image || DefaultUserRound} alt="user_image" />
                            <span className={`ml-2 ${commentscss.fs15}`} style={{ fontWeight: "600" }}>
                              {/* {comment.createdByData.name} */}
                              {createdByUser.name || ""}
                            </span>
                            <span className={`ml-2 ${commentscss.greyLabel}`}>{dayjs(comment.updatedAt).format("MMM D YYYY hh:mm A")} <>&nbsp;<EditIcon className={commoncss.clickable} height={14} onClick={() => { setEditComment(comment); setEditCommentModal(true) }} /></></span>
                          </div>
                          <div>
                            <span style={{ fontSize: "14px" }}>Assigned to</span>
                            <img className="vaMiddle ml-1" style={{ "borderRadius": "50%" }} width={25} height={25} src={assigneeUser?.profile_image || DefaultUserRound} alt="user_image" />
                            <span className={`ml-1`} style={{ fontSize: "14px" }}>
                              {/* {comment.assigneeData.name} */}
                              {assigneeUser.name || ""}
                            </span>
                            <span className={`ml-2`} style={{ fontSize: "14px" }}><CalenderIcon
                              className="vaMiddle"
                              width={20}
                              height={20}
                              style={{ "margin-top": "-3px" }}
                            /> Due Date {dayjs(comment.dueDate).format("MMM D YYYY")}</span>
                            {userData?._id === comment.createdBy && (
                              <span
                                ref={(el) => (thRefs.current[comment._id] = el)}
                                onClick={() => handleClick(comment._id, comment)}
                                onMouseLeave={handleMouseLeave}
                                style={{ cursor: "pointer" }}
                              ><MenuDotIcon /></span>)}
                          </div>
                        </div>
                        <hr className="mt-2 mb-2" />
                        <div>
                          <span className={commentscss.commentText}>
                            {comment.text}
                          </span>
                          <div className="mt-2" style={{ "display": "flex", "justify-content": "flex-end" }}>
                            <span></span>
                            {/* <span> */}
                            {comment.replies && comment.replies.length > 0 && (
                              <span className={commoncss.clickable} style={{ "width": "100px", "align-content": "space-around", "text-align": "center" }} onClick={() => { commentThreadHandler(comment._id) }}>
                                <span style={{ "color": "green" }}>●</span>&ensp;<span className={commoncss.labelBlack} style={{ fontSize: "13px" }}>{comment.replies.length} {comment.replies.length > 1 ? 'replies' : 'reply'}</span>
                              </span>
                            )}
                            {/* </span> */}
                            <span style={{ "display": "flex", "justify-content": "space-between", "width": "250px" }}>

                              <button className={`${buttoncss.custom_btn}`} style={{ "border": "unset", "padding": "5px 10px", "min-width": "unset", "width": "130px" }} onClick={() => { commentThreadHandler(comment._id) }} >
                                <span className={commoncss.labelBlack} style={{ fontSize: "14.4px" }}><ReplyIcon /> Reply</span>
                              </button>
                              &ensp;
                              <Select
                                value={{ "label": comment.status, "value": comment.status }}
                                onChange={(e) => {
                                  updateCommentStatus(comment._id, comment.assigneeData._id, e.value)

                                }}
                                options={commentStatuses}
                                className={`mt-0  ${commoncss.w260}`}
                                classNamePrefix="select"
                                components={{
                                  ...animatedComponents,
                                  IndicatorSeparator: () => null
                                }}
                                styles={
                                  comment.status === "unresolved"
                                    ? unresolvedCustomStyles
                                    : comment.status === "overdue"
                                      ? overdueCustomStyles
                                      : comment.status === "resolved"
                                        ? resolvedCustomStyles
                                        : closedCustomStyles
                                }
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                })
              )}

              {selectComment && (
                <div
                  className={commoncss.itemMenuContainer}
                  onMouseEnter={handlePopupEnter}
                  onMouseLeave={handleMouseLeave}
                  style={{
                    top: popupPosition.top,
                    left: popupPosition.left,
                  }}
                >
                  <div className={`${commoncss.itemMenu}`} onClick={() => { setEditCommentModal(true) }}>Edit Comment</div>
                  <div
                    className={`${commoncss.clickable} ${commoncss.itemMenu}`}
                    onClick={() => {
                      deleteComment(selectComment);
                    }}
                  >
                    Delete Comment
                  </div>
                </div>
              )}

              {selComment && showCommentThread && selComment.length > 0 && (
                selComment.map((comment, index) => {

                  const createdByUser = usersData.find(u => u._id === comment.createdBy) || null;

                  return (
                    <div className={`mt-1 mb-2 ${commentscss.commentsCard}`} key={index}>
                      <div className={commoncss.flexCenter} style={{ "justify-content": "space-between" }}>
                        <div>
                          <LeftIcon className={commoncss.clickable} height={15} width={15} onClick={() => { setShowCommentThread(false) }} />&ensp;Thread by
                          <img className="vaMiddle ml-2" style={{ "borderRadius": "50%" }} width={30} height={30} src={createdByUser?.profile_image || DefaultUserRound} alt="user_image" />
                          <span className={`ml-2 ${commentscss.fs15}`} style={{ fontWeight: "600" }}>
                            {/* {comment.createdByData.name} */}
                            {createdByUser?.name || ""}
                          </span>
                          {/* <span className={`ml-2 ${commentscss.greyLabel}`}>{dayjs(comment.updatedAt).format("MMM D YYYY hh:mm A")}</span> */}
                        </div>
                        <div className={commoncss.dFlex}>
                          <span className={`${commoncss.labelBlack} mr-3`} style={{ fontSize: "14.4px" }}>{comment.replies.length > 1 ? `${comment.replies.length} comments` : `${comment.replies.length} comment`}</span>
                          <Select
                            value={{ "label": comment.status, "value": comment.status }}
                            onChange={(e) => {
                              updateCommentStatus(comment._id, comment.assigneeData._id, e.value)
                            }}
                            options={commentStatuses}
                            className={`mt-0  ${commoncss.w260}`}
                            classNamePrefix="select"
                            components={{
                              ...animatedComponents,
                              IndicatorSeparator: () => null
                            }}
                            styles={
                              comment.status === "unresolved"
                                ? unresolvedCustomStyles
                                : comment.status === "overdue"
                                  ? overdueCustomStyles
                                  : comment.status === "resolved"
                                    ? resolvedCustomStyles
                                    : closedCustomStyles
                            }
                          />
                        </div>
                      </div>
                      <hr className="mt-2 mb-2" />
                      <div>
                        <div>
                          <div className="mt-2">
                            <img className="vaMiddle" style={{ "borderRadius": "50%" }} width={30} height={30} src={createdByUser?.profile_image || DefaultUserRound} alt="user_image" />
                            <span className={`ml-2 ${commentscss.fs15}`} style={{ fontWeight: "600" }}>
                              {/* {comment.createdByData.name} */}
                              {createdByUser?.name || ""}
                            </span>
                            <span className={`ml-2 ${commentscss.greyLabel}`}>{dayjs(comment.updatedAt).format("MMM D YYYY hh:mm A")}{userData?._id === comment.createdBy && (<>&nbsp;<EditIcon className={commoncss.clickable} height={14} onClick={() => { setEditComment(comment); setEditCommentModal(true) }} /></>)}</span>
                          </div>
                          <div className={`mt-2 p-2 ${commentscss.commentText}`}>
                            {comment.text}
                          </div>
                        </div>
                        {comment.replies && comment.replies.length > 0 && (
                          <div>
                            <div className={`${commoncss.flexCenter} m-3`}>
                              <span className={commoncss.primaryLableColor} style={{ "width": "100px", "font-size": "14px" }}>
                                {comment.replies.length} Replies
                              </span>
                              <span style={{ "width": "-webkit-fill-available" }}>
                                <hr className={`mt-2 mb-2 ${commoncss.hr2}`} />
                              </span>
                            </div>
                            {comment.replies.map((reply, index) => {

                              const commentReplyBy = usersData.find(u => u._id === reply.createdBy) || null;

                              return(
                                <div className="px-3 mb-4">
                                  <div className="mt-2">
                                    <img className="vaMiddle" style={{ "borderRadius": "50%" }} width={30} height={30} src={commentReplyBy?.profile_image || DefaultUserRound} alt="user_image" />
                                    <span className={`ml-2 ${commentscss.fs15}`} style={{ fontWeight: "600" }}>
                                      {/* {reply.name} */}
                                      {commentReplyBy?.name || ""}
                                    </span>
                                    <span className={`ml-2 ${commentscss.greyLabel}`}>{dayjs(reply.updatedAt).format("MMM D YYYY hh:mm A")}</span>
                                  </div>
                                  <div className={`mt-2 p-2 ${commentscss.commentText}`}>
                                    {reply.text}
                                  </div>
                                </div>
                              )
                            })}

                          </div>
                        )}
                        <div className="px-3 mb-4">
                          <InputGroup
                            inputs={[
                              <>
                                <span className={commoncss.imgIconInput}>
                                  <input type="text" placeholder="Type a reply" onChange={(e) => { setCommentReply(e.target.value) }} />
                                  <span className={`icon ${commoncss.clickable}`} style={{ "pointer-events": "unset" }} onClick={() => { postCommentReply(comment._id, addTaskForm.taskId) }} >
                                    <RoundedCheckIcon
                                      className="vaMiddle"
                                      width={20}
                                      height={20}
                                    />
                                  </span>
                                </span>
                              </>,
                            ]}
                          />
                        </div>

                      </div>
                    </div>
                  )
                })
              )}
            </div>

            <div
              class={`${commoncss.pdlr15} ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerRight} `}
              style={{ "overflow": "auto", "height": "65vh" }}
            >
              <>
              </>
              <InputGroup
                label={
                  <div className="attachments-button-label">
                    <span>Workings & Remarks</span>
                    <div>
                      <input
                        type="file"
                        id="fileInput"
                        style={{ display: "none" }}
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.eml,.msg"
                        multiple
                        onChange={handleFilesChange}
                        disabled={isInputDisabled({ taskDetails, userData, roles: ["task-approver","task-preparer"]})}
                      />
                      <button
                        type="button"
                        className="attach-files-btn"
                        onClick={() => document.getElementById("fileInput").click()}
                      >
                        <AttachmentIcon className={commoncss.vaMiddle} width={18} />
                        <span>Attach files</span>
                      </button>
                    </div>
                  </div>
                }
                inputs={[
                  <>
                    <textarea
                      value={addTaskForm?.workingsAndRemarks || ""}
                      placeholder="Type Something..."
                      onChange={(e) =>
                        setAddTaskForm((prev) => ({
                          ...prev,
                          workingsAndRemarks: e.target.value,
                        }))
                      }
                      rows={7}
                      disabled={isInputDisabled({ taskDetails, userData, roles: ["task-preparer"]})}
                    />

                    {(existingFiles.length > 0 || attachedFiles.length > 0) && (
                      <div className="files-container">
                        <div className="files-list">
                          <span className="attach-label">Attached Files</span>

                          {(showAll
                            ? [...existingFiles, ...attachedFiles]
                            : [...existingFiles, ...attachedFiles].slice(0, 3)
                          ).map((file, idx) => {
                            const isExisting = !!file._id;
                            const displayName = file.originalName || file.name;

                            const handleDownload = async () => {
                              if (!file.url) return;
                              try {
                                const response = await fetch(file.url);
                                const blob = await response.blob();
                                const downloadUrl = window.URL.createObjectURL(blob);

                                const a = document.createElement("a");
                                a.href = downloadUrl;
                                a.download = displayName;
                                document.body.appendChild(a);
                                a.click();
                                a.remove();
                                window.URL.revokeObjectURL(downloadUrl);
                              } catch (err) {
                                console.error("Download failed:", err);
                              }
                            };

                            return (
                              <div
                                key={file._id || idx}
                                className="file-card"
                                style={{ cursor: isExisting ? "pointer" : "default" }}
                                onClick={() => {
                                  if (isExisting) handleDownload();
                                }}
                              >
                                <div className="file-icon">{getFileIcon(displayName)}</div>
                                <span className="file-name">{displayName}</span>

                                {!isInputDisabled({ taskDetails, userData, roles: ["task-preparer"] }) && (
                                  <button
                                    type="button"
                                    className="remove-btn"
                                    onClick={(e) => {
                                      e.stopPropagation(); 
                                      if (isExisting) handleRemoveExisting(file._id);
                                      else handleRemoveNew(idx - existingFiles.length);
                                    }}
                                  >
                                    <CloseGreyIcon />
                                  </button>
                                )}
                              </div>
                            );
                          })}
                          {[...existingFiles, ...attachedFiles].length > 3 && (
                          <button
                            type="button"
                            className="view-more-btn"
                            onClick={() => setShowAll((prev) => !prev)}
                          >
                            {showAll
                              ? "View less"
                              : `+${existingFiles.length + attachedFiles.length - 3} More`}
                          </button>
                        )}
                        </div>

                        
                      </div>
                    )}
                  </>
                ]}
              />
              
              <div className={`${tablecss.tableContainer} ${tablecss.hoverWt}`}>
                <table className={`${tablecss.customTable} ${tablecss.taskTable} ${tablecss.adjCustomTable}`}>
                  <thead>
                    <tr>
                      <th >
                        <span class="text-danger">* </span>
                        Date
                      </th>
                      <th >
                        <span class="text-danger">* </span>
                        Ledger Code
                      </th>
                      <th >
                        <span class="text-danger">* </span>
                        Ledger Name
                      </th>
                      <th >
                        <span class="text-danger">* </span>
                        Amount
                      </th>
                      <th >
                        Remarks
                      </th>
                      <th >Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {adjustments?.length > 0 &&
                      adjustments.map((adjustment, ax) => (
                        <React.Fragment key={ax}>
                          {adjustment?.addedLedgers?.length > 0 &&
                            adjustment.addedLedgers.map((ledger, lx) => (
                              <>
                                <tr key={lx}>
                                  {lx === 0 && (
                                    <td className={`text-left ${commoncss.noBorder} ${commoncss.vaTop}`} rowSpan={adjustment?.addedLedgers.length}>
                                      <>
                                        <div className="input-group-wrapper">
                                          <div className="input-group">
                                            <div className={`input-col`} style={{ "width": "150px" }}>
                                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer components={["MobileDatePicker"]}>
                                                  <MobileDatePicker
                                                    disabled={isInputDisabled({ taskDetails, userData, roles: ["task-preparer"]})}
                                                    slotProps={{
                                                      textField: {
                                                        name: "date",
                                                        className: `${commoncss.adjDatePickerContainer}`,
                                                        style: { "width": "100px !important" },
                                                        placeholder: "Select date",
                                                        InputProps: {
                                                          disableUnderline: true,
                                                        },
                                                        inputProps: {
                                                          placeholder: "Select date",
                                                        },
                                                        sx: {
                                                          '& fieldset': {
                                                            border: 'none',
                                                          },
                                                        },
                                                      },
                                                    }}
                                                    value={adjustment?.date ? dayjs(adjustment.date) : null}
                                                    onChange={(value) => {
                                                      // mimic native input's target structure
                                                      const adjDateEvent = { target: { name: "date", value: value?.format("YYYY-MM-DD") } };
                                                      dispatch(setOnchangeAdj(ax, null, adjDateEvent.target, adjustments, ledgers));
                                                    }}
                                                    format="DD-MMM-YYYY" // same format as native input[type="date"]
                                                  />
                                                </DemoContainer>
                                              </LocalizationProvider>

                                              <span className="icon">
                                                <CalenderIcon
                                                  className="vaMiddle"
                                                  width={20}
                                                  height={20}
                                                />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    </td>
                                  )}

                                  <td className={`text-left ${commoncss.noBorder} ${commoncss.vaTop}`}>
                                    <InputGroup
                                      inputs={[
                                        <>
                                          <Select
                                            className="w-100 mt-0"
                                            classNamePrefix="select"
                                            components={{
                                              ...animatedComponents,
                                              IndicatorSeparator: () => null,
                                              DropdownIndicator: CustomDropdownIndicator,
                                            }}
                                            styles={{
                                              ...customStylesWbg,
                                              container: (provided) => ({
                                                ...provided,
                                                width: 'fit-content',
                                                minWidth: '110px',
                                              }),
                                            }}
                                            menuPortalTarget={document.body}
                                            name="ledgerCode"
                                            value={ledger?.ledgerCode ? { value: ledger.ledgerCode, label: ledger.ledgerCode } : null}
                                            onChange={(selectedOption) => {
                                              const syntheticEvent = { name: 'ledgerCode', value: selectedOption?.value ?? '' };
                                              dispatch(setOnchangeAdj(ax, lx, syntheticEvent, adjustments, ledgers));
                                            }}
                                            options={[
                                              ...(ledger?.ledgerCode && !ledgers.some((l) => l.ledgerCode === ledger.ledgerCode)
                                                ? [{ value: ledger.ledgerCode, label: ledger.ledgerCode }]
                                                : []),
                                              ...ledgers.map((l) => ({ value: l.ledgerCode, label: l.ledgerCode })),
                                            ]}
                                            placeholder=""
                                            isDisabled={isInputDisabled({ taskDetails, userData, roles: ["task-preparer"]})}
                                          />
                                        </>,
                                      ]}
                                    />
                                  </td>

                                  <td className={`text-left ${commoncss.noBorder} ${commoncss.vaTop}`}>
                                    <InputGroup
                                      inputs={[
                                        <>
                                          <Select
                                            className="w-100 mt-0"
                                            classNamePrefix="select"
                                            components={{
                                              ...animatedComponents,
                                              IndicatorSeparator: () => null,
                                              DropdownIndicator: CustomDropdownIndicator,
                                            }}
                                            styles={{
                                              ...customStylesWbg,
                                              container: (provided) => ({
                                                ...provided,
                                                width: 'fit-content',
                                                minWidth: '150px',
                                              }),
                                            }}
                                            menuPortalTarget={document.body}
                                            name="ledgerName"
                                            value={ledger?.ledgerName ? { value: ledger.ledgerName, label: ledger.ledgerName } : null}
                                            onChange={(selectedOption) => {
                                              const nameVal = selectedOption?.value ?? '';
                                              dispatch(setOnchangeAdj(ax, lx, { name: 'ledgerName', value: nameVal }, adjustments, ledgers));

                                              const match = ledgers.find((l) => l.ledgerName === nameVal);
                                              if (match) {
                                                dispatch(setOnchangeAdj(ax, lx, { name: 'ledgerCode', value: match.ledgerCode }, adjustments, ledgers));
                                              }
                                            }}
                                            options={[
                                              ...(ledger?.ledgerName && !ledgers.some((l) => l.ledgerName === ledger.ledgerName)
                                                ? [{ value: ledger.ledgerName, label: ledger.ledgerName }]
                                                : []),
                                              ...ledgers.map((l) => ({ value: l.ledgerName, label: l.ledgerName })),
                                            ]}
                                            placeholder=""
                                            isDisabled={isInputDisabled({ taskDetails, userData, roles: ["task-preparer"]})}
                                          />
                                        </>,
                                      ]}
                                    />
                                  </td>

                                  <td className={`text-left ${commoncss.noBorder} ${commoncss.vaTop}`}>
                                    <div className={commoncss.flexCenter}>
                                      <InputGroup
                                        inputs={[
                                          <>
                                            <input
                                              type="number"
                                              className={commoncss.plainInput}
                                              value={ledger?.adjustmentAmount}
                                              name="adjustmentAmount"
                                              onChange={(e) => {
                                                dispatch(setOnchangeAdj(ax, lx, e.target, adjustments, ledgers))
                                              }}
                                              disabled={isInputDisabled({ taskDetails, userData, roles: ["task-preparer"]})}
                                            />
                                          </>,
                                        ]}
                                      />&ensp;&ensp;
                                      {!isInputDisabled({ taskDetails, userData, roles: ["task-preparer"] }) && (
                                        <CloseIcon width={15} onClick={() => dispatch(removeAdjustmentFromTable(ax, lx, adjustments))} />
                                      )}
                                    </div>
                                  </td>
                                  {lx === 0 && (
                                    <>
                                      <td className={`text-left ${commoncss.noBorder}  ${commoncss.vaTop}`} rowSpan={adjustment?.addedLedgers.length}>
                                        <InputGroup
                                          inputs={[
                                            <>
                                              <textarea
                                                className={commoncss.plainInput}
                                                value={adjustment?.remarks}
                                                name="remarks"
                                                onChange={(e) => {
                                                  dispatch(setOnchangeAdj(ax, null, e.target, adjustments, ledgers));
                                                }}
                                                disabled={isInputDisabled({ taskDetails, userData, roles: ["task-preparer"]})}
                                              />
                                            </>,
                                          ]}
                                        />

                                      </td>
                                      <td className={`${commoncss.noBorder}  ${commoncss.vaTop}`} rowSpan={adjustment?.addedLedgers.length} >
                                        <div className={commoncss.flexCenter}>
                                          <button
                                            onClick={() => SaveSingleAdj(adjustment)}
                                            className={`px-2 py-1 rounded ${buttoncss.primary}`}
                                            disabled={isInputDisabled({ taskDetails, userData, roles: ["task-preparer"]})}
                                          >
                                            {adjustment?._id ? "Update" : "Save"}
                                          </button>
                                        </div>
                                      </td>
                                    </>
                                  )}
                                </tr>
                                {lx === adjustment.addedLedgers.length - 1 && (
                                  <>
                                    {!isInputDisabled({ taskDetails, userData, roles: ["task-preparer"] }) && (
                                      <tr>
                                        <td className={`text-left ${commoncss.noBorder}`}></td>
                                        <td colSpan={1} className={`text-left ${commoncss.noBorder}`} style={{ paddingTop:"0px"}}>
                                          <button
                                            className={`rounded ${buttoncss.secondary} ${commoncss.noBorder}`}
                                            onClick={() => dispatch(addLedgerToAdjustment(ax, adjustments))}
                                          >
                                            + Add row
                                          </button>
                                        </td>
                                         <td className={`text-left ${commoncss.noBorder}`} colSpan={7}></td>
                                      </tr>
                                    )}
                                    <tr>
                                      <td colSpan="9" className={commoncss.borderBottom}></td>
                                    </tr>
                                  </>
                                )}
                              </>
                            ))}
                        </React.Fragment>
                      ))}
                    {!isInputDisabled({ taskDetails, userData, roles: ["task-preparer"] }) && (
                      <tr>
                        <td scope="row" colSpan={6}>
                          <TableButton
                            btnColor={buttoncss.secondary}
                            label="Add Adjustment"
                            icon={<PrimaryPlusIcon />}
                            onClick={() => {
                              dispatch(setNewAdjustmentToTable(adjustments));
                            }}
                          />

                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <br />
              {checkReviewed === "N" && (
                <div>
                  {connectedTasks && connectedTasks.length > 0 && (
                    <>
                      <div className={commoncss.dFlexJustifysb}>
                        <label className={commoncss.primaryLableColor}>Connected Tasks</label>
                        <Button
                          class_={`mb-2 ${buttoncss.custBtnPadding}`}
                          btnColor={`${buttoncss.secondary} ${buttoncss.subBtn}`}
                          icon={<RoundedCheckIcon width={18} />}
                          label="Reviewed All"
                          onClick={() => { reviewAllTasks() }}
                        />
                      </div>
                      <BookClosureConnectedTasks ViewTaskMore={ViewTaskMore} connectedTasks={connectedTasks} parentTaskId={addTaskForm.taskId} />
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </Modal>
      )}

      <AddLedgerToTaskModal AddLedgerToTask={AddLedgerToTask} />
      <EditLedgerTaskModal
        UpdateLedgerInTask={() =>
          UpdateLedgerInTask(
            ledgerDetails.ledgerId,
            ledgerDetails.remark,
            ledgerDetails.amount
          )
        }
        ledgerDetails={ledgerDetails}
        setLedgerDetails={setLedgerDetails}
      />

      {addCommentModal && (
        <AddCommentModal
          setAddCommentModal={setAddCommentModal}
          taskId={addTaskForm.taskId}
          assignOptions={assignOptions}
          setCommentsList={setCommentsList}
          taskComment={taskComment}
          setTaskComment={setTaskComment}
        />
      )}

      {addCommentModal && (
        <AddCommentModal
          setAddCommentModal={setAddCommentModal}
          taskId={addTaskForm.taskId}
          assignOptions={assignOptions}
          setCommentsList={setCommentsList}
          taskComment={taskComment}
          setTaskComment={setTaskComment}
        />
      )}

      {editCommentModal && (
        <EditCommentModal
          setEditCommentModal={setEditCommentModal}
          taskId={addTaskForm.taskId}
          assignOptions={assignOptions}
          setCommentsList={setCommentsList}
          taskComment={taskComment}
          setTaskComment={setTaskComment}
          editComment={editComment}
          taskDetails={taskDetails}
          userData={userData}
        />
      )}


      {deleteTaskModal && displayModal && (
        <Modal
          headerActions={
            <CloseIcon
            onClick={() => {
              setDisplayModal(false);
              setDeleteTaskModal(false);
            }}
            className="clickable"
            />
          }
          headerBottomLine={false}
          >
          <span className={`${modalcss.modalBodyHead} mb-1`}>
            Do you want to <span className="fw700">delete</span> the
            task?
          </span>
          <span
            className={`${modalcss.modalBodycnt}`}
            style={{ "margin-bottom": "35px" }}
          >
            Once deleted, you can restore the task from the bin
          </span>
          <span
            className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
          >
            <Button
              btnColor={buttoncss.danger}
              label="Yes, Delete"
              onClick={DeleteTask}
            />
            <Button
              btnColor={buttoncss.secondary_del}
              label="No, Cancel"
              onClick={() => {
                setDisplayModal(false);
                setDeleteTaskModal(false);
              }}
            />
          </span>
          </Modal>
        )}
    </>
  );
};




export default AddTaskModal;
